<template lang="pug">
  .tab-container.width-100.row
    sidebar-index(
      :author='resource.mainAuthor'
      :resourceTitle='resource.title'
      :classes='activeLocalizedResource.classPlans.length'
      isStudentView
      isStudentTab
    )
    .content.item-1
      router-view
</template>

<script>
import { mapState } from 'vuex'
import SidebarIndex from './SidebarIndex'
import { languagesCodesToString } from '../../../constants/languages'
import kreaResourceRedirection from '@/mixins/kreaResourceRedirection'

export default {
  mixins: [kreaResourceRedirection],
  components: { SidebarIndex },
  computed: {
    ...mapState({
      resource: state => state.kreaResource.resource,
      activeLanguage: state => state.kreaResource.activeLanguage
    }),
    activeLocalizedResource() {
      return this.resource.localizedResources.find(res => languagesCodesToString[res.locale] === this.activeLanguage)
    }
  }
}
</script>

<style lang="scss">
@import 'src/scss/variables/colors';
@import 'src/scss/variables/sizes';
@import 'src/scss/common/texts';
@import 'src/scss/common/markdown';

.sidebar{
  width: 420px;
}

.content {
  margin-left: 50px;
  width: 100%;
}
</style>
